'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'paperclip';
var width = 512;
var height = 512;
var aliases = [128206];
var unicode = 'f0c6';
var svgPathData = 'M241.4 18.4c53.1-53.1 139.2-53.1 192.3 0s53.1 139.2 0 192.3L264 380.5c-34.4 34.4-90.1 34.4-124.5 0s-34.4-90.1 0-124.5L298 97.6c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L173.5 289.9c-15.6 15.6-15.6 40.9 0 56.6s40.9 15.6 56.6 0L399.8 176.8c34.4-34.4 34.4-90.1 0-124.5s-90.1-34.4-124.4 0l-181 181c-53.1 53.1-53.1 139.2 0 192.3s139.2 53.1 192.3 0L428.1 284.3c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L320.6 459.6c-71.9 71.9-188.4 71.9-260.2 0s-71.9-188.4 0-260.2l181-181z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPaperclip = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;